export default {"src":"/_next/static/media/COTY.57f39f7e.svg","height":18,"width":18};